import { Reveal } from "@/components/motion/Reveal";

const Tile = ({ a, className, delay, no }) => (
  <Reveal delay={delay} className={`group relative overflow-hidden bg-[#0E1726] ${className}`} data-testid={`focus-tile-${a.id}`}>
    <img src={a.image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B1220]/85 via-[#0B1220]/25 to-transparent" />
    <span className="absolute left-0 top-0 bg-accent px-3 py-1.5 font-mono text-[12px] text-accent-ink">{no}</span>
    <div className="relative flex h-full flex-col justify-end p-6 text-white sm:p-8">
      <h3 className="font-display text-3xl font-semibold leading-tight tracking-[-0.03em] sm:text-4xl">{a.title}</h3>
      <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-white/85">{a.body}</p>
    </div>
  </Reveal>
);

// Asymmetric 2x2 bento on a hairline grid: wide/narrow on row one, narrow/wide on row two.
const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7"];

export const FocusBento = ({ areas = [] }) => (
  <div className="grid gap-px border border-line bg-line lg:grid-cols-12" data-testid="focus-bento">
    {areas.map((a, i) => (
      <Tile key={a.id} a={a} no={String.fromCharCode(65 + i)} delay={i * 0.08} className={`h-[340px] sm:h-[400px] lg:h-[440px] ${SPANS[i % 4]}`} />
    ))}
  </div>
);
